import themesConfig from 'app/configs/themesConfig';
import i18n from '../../i18n';

const settingsConfig = {
  layout: {
    style: 'layout1',
    config: {},
  },
  customScrollbars: true,
  direction: i18n.dir(i18n.options.lng) || 'ltr',
  theme: {
    main: themesConfig.light,
    navbar: themesConfig.dark,
    toolbar: themesConfig.light,
    footer: themesConfig.dark,
  },
};

export const PENDING_URL_KEY = 'pndngUrlkey';
export const PENDING_PARAMS_KEY = 'pndingPrmskey';

// ----- Ruta por default para redirigir cuando usuario este sesión ----------
export const defaultLoginRedirect = '/dashboard';
// ----- Ruta por default para redirigir cuando usuario cerre sesión ----------
export const defaultLogoutRedirect = '/sign-in';

export default settingsConfig;
